import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const IMAGES = [
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=900&q=80",
];

export default function Blog() {
  const { t } = useI18n();
  const posts = t.blog.posts;
  return (
    <section id="blog" className="py-24 sm:py-32 border-t border-white/5" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs tracking-[0.4em] text-[#FF6B00] uppercase">{t.blog.eyebrow}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 uppercase">{t.blog.title}</h2>
          <p className="mt-4 text-zinc-400">{t.blog.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="lift-card group cursor-pointer"
              data-testid={`blog-post-${i}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden zoom-wrap mb-5">
                <img src={IMAGES[i]} alt={p.title} className="absolute inset-0 w-full h-full object-cover zoom-img" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute top-4 left-4 px-3 py-1.5 bg-[#FF6B00] text-black text-[10px] tracking-[0.25em] font-bold uppercase">
                  {t.blog.categories[p.cat]}
                </div>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl uppercase leading-tight group-hover:text-[#FF6B00] transition">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{p.excerpt}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#FF6B00]">
                {t.blog.readMore} <ArrowUpRight size={14} />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
